import Video11 from '../slide/providersIDHN.mp4';

function Providers(){
    return(
        <div style={{}}>
               <video  className=''src={Video11}   autoPlay={true}  style={{width:'100%', height:'50vw'}}/>
        </div>
    )
}

export default Providers;